<template>
    <div>
        <div class="row mb-3 mt-5">
            <div class="col-3 model rounded-8" @click="goToEditor('free', 'halloween.json')">
                <div class="wrap">
                    <div class="thumbnail">
                        <img src="/images/email/halloween.png" alt="" />
                    </div>
                </div>
                <h5 class="mt-3 model-title">Halloween</h5>
            </div>

            <div class="col-3 model rounded-8" @click="goToEditor('free', 'new_year.json')">
                <div class="wrap">
                    <div class="thumbnail">
                        <img src="/images/email/new_year.png" alt="" />
                    </div>
                </div>
                <h5 class="mt-3 model-title">New year</h5>
            </div>

            <div class="col-3 model rounded-8" @click="goToEditor('free', 'noel.json')">
                <div class="wrap">
                    <div class="thumbnail">
                        <img src="/images/email/noel.png" alt="" />
                    </div>
                </div>
                <h5 class="mt-3 model-title">Noel</h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CompaingEmailsModelsFree',
    props: ['url'],
    data: () => ({
        //
    }),
    methods: {
        goToEditor(type, filename) {
            const urlParams = new URLSearchParams(window.location.search)
            window.location.href =
                this.url +
                    '?folder=' +
                    type +
                    '&model=' +
                    filename +
                    '&campaigne_email_uuid=' +
                    urlParams.get('campaigne_email_uuid') || ''
        },
    },
}
</script>

<style scoped>
.text-muted {
    color: #94a3b8 !important;
}

.collaps {
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid rgba(123, 130, 137, 0.3);
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.05);
    padding: 1rem 2rem;
    margin-top: 15px;
}

.collaps-subtitle {
    margin: 0;
    font-weight: 500;
}

.collaps-description {
    margin-bottom: 0 !important;
}

.btn-plr-15 {
    padding: 0 1.5rem !important;
}

.btn-primary {
    width: 200px;
    height: 40px !important;
    border-radius: 24px !important;
}

.btn-primary-inverse {
    height: 40px !important;
    border-radius: 24px !important;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.icon {
    text-align: center;
    font-size: 2rem;
    padding: 0;
}

.icon .fa {
    color: #ccc;
    margin-top: 15px;
}

.text-muted {
    color: #7b8289;
}

.float-right {
    float: right;
}

label {
    font-weight: normal !important;
}

input {
    border-radius: 2px !important;
}

.radio-container {
    color: white;
    cursor: pointer;
    padding: 0.2rem;
    padding-top: 1.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
}

.selected-container {
    background-color: rgba(98, 194, 246, 0.08);
    border: 1px solid rgba(98, 194, 246, 1);
}

/* Hide the default radio button */
.custom-radio {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.custom-radio + label {
    position: relative;
    padding-left: 50px;
    cursor: pointer;
    display: inline-block;
    color: black; /* Default label color */
}

.radio-description {
    padding-left: 50px;
    font-size: 0.8rem;
    cursor: pointer;
}

.custom-radio + label::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(98, 194, 246, 1);
    border-radius: 50%;
    background-color: white;
}

/* Custom radio button checked state */
.custom-radio:checked + label::before {
    background-color: rgba(98, 194, 246, 1);
}

.custom-radio:checked + label {
    color: rgba(98, 194, 246, 1); /* Label color when selected */
}

.mx-input {
    border-radius: 5px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.compaine-img-block {
    margin-top: 1rem;
    width: 100%;
    max-height: 500px;
}

.pagination {
    display: flex;
    margin: 0.25rem 0.25rem 0;
}
.pagination button {
    flex-grow: 1;
}
.pagination button:hover {
    cursor: pointer;
}

#exclude_emails .vs__dropdown-menu {
    height: 350px;
}

.model {
    height: 400px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.wrap {
    margin: 1px;
}

.thumbnail {
    background: #fff;
    height: 330px;
    border: 2px solid #f7f7f7;
    overflow: hidden;
}

.thumbnail img {
    -webkit-transition: transform 7s;
    -moz-transition: transform 7s;
    transition: transform 5s;
    width: 100%;
}

.thumbnail:hover img {
    transform: translateY(-71%);
}

.model-title {
    padding: 0;
    text-align: center;
}
</style>
